/**
 * This is the establishMemword routes configuration.
 * Only configure routes in this file.
 * @memberOf establishMemword Module
 * @namespace establishMemword Routes
 */
import establishMemwordTemplate from './establishmemword.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf establishMemword Module.establishMemword Routes
 * @ngInject
 */
var config = function ($stateProvider) {

    /* Create the establishMemword state and assign the template and controller. */
    $stateProvider
		.state('login.establishmemword', {
			url: '/establishmemword',
			template: establishMemwordTemplate,
			controller: 'establishMemwordController',
			controllerAs: 'establishMemwordController'
		});
}

export default config;



// WEBPACK FOOTER //
// ./src/login/establishmemword/establishmemword.route.js